import React from 'react'

import { IClientExperienceV7Data } from '@unionco/alaris-app-types'
import { StyledMarkDown } from 'components/MarkDown'
import { ModuleCard } from 'components'

interface IClientExperienceV7ModuleProps {
    data: IClientExperienceV7Data
}

export const ClientExperienceV7Module: React.FC<
    IClientExperienceV7ModuleProps
> = ({ data: { items } }) => {
    if (!items) return <></>
    const title = 'Client Experience V7' //TODO
    return (
        <>
            <div className="u-text-left">
                <h5 className="u-self-start u-pb-6 u-text-left">{title}</h5>
                {items && (
                    <ModuleCard.Body
                        innerCardPadding={['u-px-8', 'u-py-6']}
                        key="ClientExperienceV7"
                        useNewStyling={true}
                    >
                        <StyledMarkDown content={items.value} />
                    </ModuleCard.Body>
                )}
            </div>
        </>
    )
}

export default ClientExperienceV7Module
